// src/components/Skeleton.js — Loading skeleton placeholders
import React from "react";

export function SkeletonCard() {
  return (
    <div className="card skeleton-card">
      <div className="skeleton-row">
        <div className="skeleton skeleton-sm" style={{ width: 80 }} />
        <div className="skeleton skeleton-sm" style={{ width: 120 }} />
        <div className="skeleton skeleton-sm" style={{ width: 60 }} />
      </div>
      <div className="skeleton-row" style={{ marginTop: 16 }}>
        <div style={{ flex: 1 }}>
          <div className="skeleton" style={{ width: "60%", height: 14 }} />
          <div className="skeleton" style={{ width: "80%", height: 12, marginTop: 8 }} />
          <div className="skeleton" style={{ width: "50%", height: 12, marginTop: 6 }} />
        </div>
        <div style={{ width: 40 }} />
        <div style={{ flex: 1 }}>
          <div className="skeleton" style={{ width: "60%", height: 14 }} />
          <div className="skeleton" style={{ width: "80%", height: 12, marginTop: 8 }} />
          <div className="skeleton" style={{ width: "50%", height: 12, marginTop: 6 }} />
        </div>
      </div>
      <div className="skeleton-row" style={{ marginTop: 16 }}>
        <div className="skeleton skeleton-sm" style={{ width: 100 }} />
        <div className="skeleton skeleton-sm" style={{ width: 80 }} />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 3 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
